import uuid from "react-native-uuid";
import * as CryptoJS from "crypto-js";

export default (
  state = {
    fieldsList: [],
    revvFieldIDsList: [],
    revvFieldIDsWithInternalField: [],
    revvFieldDefs: {},
    loadingFields: false,
    // from data playfield
    dataSourceSelected: "",
    sfObjects: [],
    dsObjects: [],
    sourceObjSchema: [],
    usedSFObjectSourceFieldSet: {},
    sfObjectFieldMapping: {},
    draggedType: "", // SOURCE_FIELD or FORM_FIELD
    draggedFieldID: "", // can be source field name, or form field id
    draggedFieldSubType: "", // internal field for form fields
    transformedData: [],
    syncDataSource: {},
    currentSelectedObject: null,
    dataStudioView: null,
    playFieldColumnDefs: [],
    selectedRows: null,
    fieldsMapping: {},
    objectFieldsMapping: [],
    unusedRevvFieldIDs: [],
    revvSignatoriesList: [],
    cardKey: "FORM",
    dataStudioMappedView: "",
    csvData: {},
    emptyMappings: [],
    triggerDetails: {},
  },
  action,
) => {
  switch (action.type) {
    case "NUKE_FIELD_SETTING":
    case "NUKE_TEMPLATE": {
      return {
        ...state,
        fieldsList: [],
        revvFieldIDsList: [],
        revvFieldIDsWithInternalField: [],
        revvFieldDefs: {},
        loadingFields: false,
        // from data playfield
        dataSourceSelected: "",
        sfObjects: [],
        dsObjects: [],
        sourceObjSchema: {},
        usedSFObjectSourceFieldSet: {},
        sfObjectFieldMapping: {},
        draggedType: "", // SOURCE_FIELD or FORM_FIELD
        draggedFieldID: "", // can be source field name, or form field id
        draggedFieldSubType: "", // internal field for form fields
        transformedData: [],
        syncDataSource: {},
        currentSelectedObject: null,
        csvFileHash: null,
        dataStudioView: null,
        playFieldColumnDefs: [],
        selectedRows: null,
        fieldsMapping: {},
        objectFieldsMapping: [],
        unusedRevvFieldIDs: [],
        emptyMappings: [],
        triggerPackageUrl: "",
      };
    }
    case "SET_KEY_FOR_CARD": {
      return {
        ...state,
        cardKey: action.payload.id,
      };
    }
    case "FETCH_FIELDS_LIST": {
      const {
        fields,
        fieldDefs,
        fieldIDsList,
        fieldIDsWithInternalField,
        signerDefs,
        signerIDsList,
        signerIDsWithInternalField,
        tableIdsList,
        tableIDsWithInternalField,
        metaFieldDefs,
        metaFieldIDsList,
        metaFieldIDsWithInternalField,
      } = action.payload;
      return {
        ...state,
        fieldsList: fields,
        revvFieldIDsList: fieldIDsList,
        revvFieldDefs: { ...fieldDefs, ...signerDefs, ...metaFieldDefs },
        revvFieldIDsWithInternalField: fieldIDsWithInternalField,
        loadingFields: false,
        signerIDsList,
        signerIDsWithInternalField,
        tableIdsList,
        tableIDsWithInternalField,
        metaFieldIDsList,
        metaFieldIDsWithInternalField,
      };
    }
    case "NUKE_FIELDS_LIST": {
      return {
        ...state,
        fieldsList: [],
      };
    }
    case "START_FETCHING_FIELDS_LIST": {
      return {
        ...state,
        loadingFields: true,
      };
    }
    case "FETCH_SF_OBJECTS":
      return {
        ...state,
        sfObjects: action.payload.sfObjects,
      };
    case "FETCH_DS_OBJECTS":
      return {
        ...state,
        dsObjects: action.payload.dsObjects,
      };

    case "FETCH_OBJECT_SCHEMA":
      return {
        ...state,
        sourceObjSchema: {
          ...state.sourceObjSchema,
          [action.payload.objectID]: action.payload.schema,
        },
      };

    case "ADD_SF_MAPPING_CONNECTION": {
      const { objectID } = action.payload;
      const currObjectMap =
        objectID in state.sfObjectFieldMapping
          ? state.sfObjectFieldMapping[objectID]
          : [];
      const currObjSFSet =
        objectID in state.usedSFObjectSourceFieldSet
          ? state.usedSFObjectSourceFieldSet[objectID]
          : {};
      return {
        ...state,
        usedSFObjectSourceFieldSet: {
          ...state.usedSFObjectSourceFieldSet,
          [objectID]: currObjSFSet,
        },
        sfObjectFieldMapping: {
          ...state.sfObjectFieldMapping,
          [objectID]: [
            ...currObjectMap,
            {
              id: uuid.v4(),
              form_field_id: "",
              source: "SF",
              object_name: objectID,
              schema: {
                meta: {
                  internal_fields: [],
                },
                source_fields: [
                  // should have name and transform
                ],
                mapping: {
                  internal_field: "",
                  operation: "concat",
                  seperator: "space",
                },
              },
            },
          ],
        },
      };
    }

    case "ADD_SF_MAPPING_FORM_FIELD": {
      const { objectID, mappingIndex, formFieldID, internalField } =
        action.payload;
      const currInternalFields = internalField ? [internalField] : [];
      const currObjectMap =
        objectID in state.sfObjectFieldMapping
          ? state.sfObjectFieldMapping[objectID]
          : [];
      return {
        ...state,
        sfObjectFieldMapping: {
          ...state.sfObjectFieldMapping,
          [objectID]: currObjectMap.map((currObj, ind) => {
            if (mappingIndex === ind) {
              return {
                ...currObj,
                form_field_id: formFieldID,
                schema: {
                  ...currObj.schema,
                  meta: {
                    internal_fields: [...currInternalFields],
                  },
                  mapping: {
                    ...currObj.schema.mapping,
                    internal_field: internalField,
                  },
                },
              };
            }
            return currObj;
          }),
        },
      };
    }

    case "ADD_SF_MAPPING_SOURCE_FIELDS": {
      const { objectID, mappingIndex, sourceFieldName } = action.payload;
      const currObjectMap =
        objectID in state.sfObjectFieldMapping
          ? state.sfObjectFieldMapping[objectID]
          : [];
      const currObjSFSet =
        objectID in state.usedSFObjectSourceFieldSet
          ? state.usedSFObjectSourceFieldSet[objectID]
          : {};
      return {
        ...state,
        usedSFObjectSourceFieldSet: {
          ...state.usedSFObjectSourceFieldSet,
          [objectID]: {
            ...currObjSFSet,
            [sourceFieldName]: true,
          },
        },
        sfObjectFieldMapping: {
          ...state.sfObjectFieldMapping,
          [objectID]: currObjectMap.map((currObj, ind) => {
            if (mappingIndex === ind) {
              return {
                ...currObj,
                schema: {
                  ...currObj.schema,
                  source_fields: [
                    ...currObj.schema.source_fields,
                    {
                      name: sourceFieldName,
                      transform: [], // important - to add an operation
                    },
                  ],
                },
              };
            }
            return currObj;
          }),
        },
      };
    }

    case "UPDATE_SOURCE_FIELD_TRANSFORM": {
      const { objectID, mappingIndex, sfTransformers } = action.payload;
      const currObjectMap =
        objectID in state.sfObjectFieldMapping
          ? state.sfObjectFieldMapping[objectID]
          : [];
      return {
        ...state,
        sfObjectFieldMapping: {
          ...state.sfObjectFieldMapping,
          [objectID]: currObjectMap.map((currObj, ind) => {
            if (mappingIndex === ind) {
              return {
                ...currObj,
                schema: {
                  ...currObj.schema,
                  source_fields: currObj.schema.source_fields.map((sf, i) => ({
                    ...sf,
                    transform: [
                      {
                        operation: sfTransformers[i],
                      },
                    ],
                  })),
                },
              };
            }
            return currObj;
          }),
        },
      };
    }

    case "UPDATE_SCHEMA_MAPPING": {
      const { objectID, mappingIndex, operation, seperator } = action.payload;
      const currObjectMap =
        objectID in state.sfObjectFieldMapping
          ? state.sfObjectFieldMapping[objectID]
          : [];
      return {
        ...state,
        sfObjectFieldMapping: {
          ...state.sfObjectFieldMapping,
          [objectID]: currObjectMap.map((currObj, ind) => {
            if (mappingIndex === ind) {
              return {
                ...currObj,
                schema: {
                  ...currObj.schema,
                  mapping: {
                    ...currObj.schema.mapping,
                    operation,
                    seperator,
                  },
                },
              };
            }
            return currObj;
          }),
        },
      };
    }

    case "DRAG_DATA_PLAYFIELD":
      return {
        ...state,
        draggedFieldID: action.payload.fieldID,
        draggedType: action.payload.type,
        draggedFieldSubType: action.payload.internalField,
      };

    case "START_DATASOURCE_SYNC": {
      const { dataSource, objectName, startDate, templateID, endDate } =
        action.payload;
      return {
        ...state,
        syncDataSource: {
          dataSource,
          objectName,
          startDate,
          endDate,
          templateID,
          status: "STARTED",
          loadMore: true,
        },
        dataStudioView: "MAPPED_VIEW",
      };
    }
    case "NUKE_DATASOURCE_SYNC": {
      return {
        ...state,
        syncDataSource: {},
        transformedData: [],
        playFieldColumnDefs: [],
      };
    }
    case "UPDATE_PLAYFIELD_DATA": {
      const {
        filterMeta,
        transformedData,
        columnDefs,
        selectedRows,
        isLoadMore,
      } = action.payload;
      if (
        // eslint-disable-next-line no-constant-condition
        true
        // filterMeta.startDate === startDate &&
        // filterMeta.endDate === endDate
      ) {
        return {
          ...state,
          transformedData: isLoadMore
            ? [...state.transformedData, ...transformedData]
            : [...transformedData],
          syncDataSource: {
            ...state.syncDataSource,
            status: "DONE",
            nextPageInfo: filterMeta.pageInfo,
            currentPageNum: filterMeta.pageInfo.nextpage - 1,
            pageCount: transformedData.length,
          },
          playFieldColumnDefs: action.payload.columnDefs,
          selectedRows: [...selectedRows],
        };
      }
      return {
        ...state,
        transformedData,
        syncDataSource: {
          ...state.syncDataSource,
          status: "DONE",
        },
        playFieldColumnDefs: columnDefs,
        selectedRows: action.payload.selectedRows,
      };
    }

    case "TOGGLE_LOADMORE_FLAG": {
      return {
        ...state,
        syncDataSource: {
          ...state.syncDataSource,
          loadMore: false,
        },
      };
    }
    case "RESET_SELECTED_DS_OBJECT":
      return {
        ...state,
        currentSelectedObject: null,
      };
    case "UPDATE_SELECTED_DS_OBJECT":
      return {
        ...state,
        currentSelectedObject: action.payload.objectName,
        objectFieldsMapping: action.payload.objectFieldsMapping,
        unusedRevvFieldIDs: action.payload.unusedRevvFieldIDs,
      };
    case "UPDATE_DATASTUDIO_VIEW":
      return {
        ...state,
        dataStudioView: action.payload,
      };
    case "UPDATE_DATASTUDIO_MAPPED_VIEW":
      return {
        ...state,
        dataStudioMappedView: action.payload,
      };
    case "UPDATE_PLAYFIELD_COLUMNDEFS":
      return {
        ...state,
        playFieldColumnDefs: action.payload,
      };
    case "DATASOURCE_SYNC_DONE":
      return {
        ...state,
        syncDataSource: {
          ...state.syncDataSource,
          status: "DONE",
        },
      };
    case "TOGGLE_FIELD_ROW_SELECTION": {
      const rowIndex = action.payload;
      if (
        Array.isArray(state.selectedRows) &&
        state.selectedRows.length > rowIndex
      ) {
        const currRowSelection = state.selectedRows[rowIndex];
        const updatedRowSelection = [...state.selectedRows];
        updatedRowSelection[rowIndex] = !currRowSelection;
        return {
          ...state,
          selectedRows: updatedRowSelection,
        };
      }
      return state;
    }
    case "NUKE_ALL_ROWS_SELECTED": {
      if (Array.isArray(state.selectedRows) && state.selectedRows.length > 0) {
        const updatedRowSelection = Array(state.selectedRows.length);
        updatedRowSelection.fill(false);
        return {
          ...state,
          selectedRows: updatedRowSelection,
        };
      }
      return state;
    }
    case "UPDATE_FIELD_MAPPING": {
      return {
        ...state,
        fieldsMapping: action.payload,
        dataStudioMappedView: "",
      };
    }
    case "UPDATE_FIELD_SCHEMA": {
      const { schema, mappingID } = action.payload;

      const { id, revvFieldID, revvSubField } = schema;
      const { objectFieldsMapping, unusedRevvFieldIDs } = state;
      // find index of mapping
      const fieldIndex = objectFieldsMapping.findIndex(
        mapping => mapping.mappingID === mappingID,
      );

      // update field mapping
      let oldFieldId = null;
      const newObjectFieldsMapping = [...objectFieldsMapping];
      if (fieldIndex > -1) {
        const oldSchema = objectFieldsMapping[fieldIndex];
        oldFieldId = oldSchema.revvSubField
          ? `${oldSchema.revvFieldID}-${oldSchema.revvSubField}`
          : oldSchema.revvFieldID;
        newObjectFieldsMapping[fieldIndex] = {
          ...objectFieldsMapping[fieldIndex],
          ...schema,
          id,
          mappingID,
          revvFieldID,
          revvSubField,
        };
      } else {
        newObjectFieldsMapping.push({
          ...schema,
          id,
          mappingID,
          revvFieldID,
          revvSubField,
        });
      }

      // check of unused fields
      const fieldID = revvSubField
        ? `${revvFieldID}-${revvSubField}`
        : revvFieldID;

      let updatedUnusedFields = null;
      if (fieldID && !oldFieldId) {
        updatedUnusedFields = unusedRevvFieldIDs.filter(fID => fID !== fieldID);
      } else if (!fieldID && oldFieldId) {
        updatedUnusedFields = [...unusedRevvFieldIDs, oldFieldId];
      } else {
        updatedUnusedFields = [...unusedRevvFieldIDs];
      }
      return {
        ...state,
        objectFieldsMapping: newObjectFieldsMapping,
        unusedRevvFieldIDs: updatedUnusedFields,
      };
    }
    case "UPDATE_MULTIPLE_MAPPING": {
      const { updatedFieldsMapping } = action.payload;
      const { objectFieldsMapping } = state;
      const newObjectFieldsMapping = objectFieldsMapping.map(mapping => {
        const { mappingID } = mapping;
        const checkInUpdatedList = updatedFieldsMapping.findIndex(
          map => map.mappingID === mappingID,
        );
        if (checkInUpdatedList > -1) {
          return updatedFieldsMapping[checkInUpdatedList];
        }
        return mapping;
      });
      return {
        ...state,
        objectFieldsMapping: newObjectFieldsMapping,
      };
    }
    case "REMOVE_FIELD_MAPPING": {
      const { revvFieldID, revvSubField, mappingID } = action.payload;
      const { objectFieldsMapping, unusedRevvFieldIDs } = state;
      const updatedList = objectFieldsMapping.filter(
        mapping => mapping.mappingID !== mappingID,
      );
      let updatedUnusedFields = [];
      const fieldID = revvSubField
        ? `${revvFieldID}-${revvSubField}`
        : revvFieldID;
      if (fieldID) {
        updatedUnusedFields = [...unusedRevvFieldIDs, fieldID];
      } else {
        updatedUnusedFields = [...unusedRevvFieldIDs];
      }
      return {
        ...state,
        objectFieldsMapping: updatedList,
        unusedRevvFieldIDs: updatedUnusedFields,
      };
    }
    case "UPDATE_DATASOURCE_SELECTED": {
      return {
        ...state,
        dataSourceSelected: action.payload,
      };
    }
    case "UPDATE_OBJECT_FIELD_MAPPING": {
      return {
        ...state,
        fieldsMapping: {
          ...state.fieldsMapping,
          [action.payload.objectName]: action.payload.objectFieldsMapping,
        },
      };
    }
    case "SET_KEY_FOR_AGGRID": {
      return {
        ...state,
        aggridValue: action.payload.data,
      };
    }
    case "SET_CSV_DATA": {
      const csvIdentifier = `${new Date().getTime()}`;
      const csvFileHash = CryptoJS.MD5(csvIdentifier).toString();
      return {
        ...state,
        csvData: { ...action.payload.data },
        currentSelectedObject: csvFileHash,
        csvFileHash,
      };
    }
    case "NUKE_CSV_DATA": {
      return {
        ...state,
        csvData: {},
      };
    }
    case "EMPTY_MAPPINGS": {
      return {
        ...state,
        emptyMappings: [...action.payload.emptyMappings],
      };
    }
    case "CREATE_TRIGGER_DETAILS": {
      return {
        ...state,
        triggerDetails: {
          ...state.triggerDetails,
          [action.payload.object_name]: { ...action.payload },
        },
      };
    }
    case "UPDATE_TRIGGER_DETAILS": {
      return {
        ...state,
        triggerDetails: {
          ...state.triggerDetails,
          [action.payload.object_name]: { ...action.payload },
        },
      };
    }
    case "FETCH_TRIGGER_DETAILS": {
      const allTriggerDetails = {};
      if (action.payload !== null) {
        action.payload.forEach(trigger => {
          allTriggerDetails[trigger.object_name] = {
            ...trigger,
          };
        });
      }
      return {
        ...state,
        triggerDetails: {
          ...allTriggerDetails,
        },
      };
    }
    case "FETCH_TRIGGER_PACKAGE_URL": {
      return {
        ...state,
        triggerPackageUrl: action.payload,
      };
    }
    default:
      return state;
  }
};
